<template>
    <div class="input-checkbox-container">
        <div class="input-checkbox rounded border" :class="internalValue ? activeClass : inactiveClass" v-on:click.prevent="internalValue = !internalValue">
            <font-awesome-icon icon="check" v-if="internalValue" />
        </div>
    </div>
</template>

<script>
    import {getTextClassFromType} from "@/utils/bootstrapTextColor";

    export default {
        name: 'boolean-selector',
        props: {
            value: {
                default: null
            },
            type: {
                type: String,
                default: 'primary',
            },
            defaultValue: {
                default: false
            },
        },
        data() {
            return {
                internalValue: this.value !== null ? this.value : this.defaultValue,
            }
        },
        mounted() {
            this.internalValue = this.value !== null ? this.value : this.defaultValue;
        },
        computed: {
            defaultClass() {
                let textClass = getTextClassFromType(this.type);

                return `border-${this.type} ${textClass}`;
            },
            activeClass() {
                return this.defaultClass + ` input-checkbox-checked bg-${this.type}`;
            },
            inactiveClass() {
                return this.defaultClass;
            }
        },
        watch: {
            internalValue(internalValue) {
                this.$emit('input', internalValue);
            },
            value(value) {
                this.internalValue = value;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "@/styles/mixins.scss";

    .input-checkbox {
        @include noSelect;

        cursor: pointer;

        width: 30px;
        height: 30px;

        border-width: 2px !important;

        padding: 2px 5px;
        margin-top: 4px;

        transition: background-color 300ms ease;
    }
</style>